import { C } from '../constants';

export default function ConfidenceBadge({ level, size="sm" }) {
  const lvl = (level||"").toLowerCase().replace(/[^a-z]/g,"");
  const norm = lvl.includes("high") ? "high" : lvl.includes("low") ? "low" : "medium";
  const cfg = {
    high:   { label:"High Confidence",   color:C.green,  bg:"rgba(0,200,5,0.1)"    },
    medium: { label:"Medium Confidence", color:C.gold2,  bg:"rgba(201,168,76,0.1)" },
    low:    { label:"Low Confidence",    color:"#FCA5A5", bg:"rgba(255,59,48,0.1)"  },
  }[norm];
  return (
    <span style={{ display:"inline-flex", alignItems:"center", gap:4, fontSize:size==="sm"?10:12, fontWeight:600, padding:size==="sm"?"2px 8px":"4px 12px", borderRadius:20, background:cfg.bg, color:cfg.color }}>
      <span style={{ width:5, height:5, borderRadius:"50%", background:cfg.color, display:"inline-block" }}/>
      {cfg.label}
    </span>
  );
}
